// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"910":"fde45b7613fcfbbc","2001":"17d2ede36b187547","7067":"c762f61e450a0896","8818":"3b832f2b11d2456e"}[chunkId] + ".css";
};